import React from 'react'
import { FormProvider, RequiredOrOptional } from './form-context'

interface FormProps {
  ariaLabel?: string
  children?: React.ReactNode
  className?: string
  id: string
  onSubmit?: React.FormEventHandler<HTMLFormElement>
  requiredOrOptionalIndicator?: RequiredOrOptional
}

export const Form: React.FC<FormProps> = ({
  ariaLabel,
  children,
  className,
  id,
  onSubmit,
  requiredOrOptionalIndicator,
}) => {
  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault()
    onSubmit?.(e)
  }

  return (
    <FormProvider value={{ formId: id, requiredOrOptionalIndicator }}>
      <form aria-label={ariaLabel} className={className} id={id} method="post" onSubmit={handleSubmit} target="_self">
        {children}
      </form>
    </FormProvider>
  )
}
